const CapitalizeFirstLetter = (word:string)=>{
   if (word) {
      return word ? word?.charAt(0).toUpperCase() + word.slice(1) : ''
   }
}

const GetUserName = (session: { givenName?: string, familyName?: string})=> {
   /* if (word) {
      return word.split('@')[0]
      // return CapitalizeFirstLetter(word.split('@')[0].split('.')[0]) + ' ' + CapitalizeFirstLetter(word.split('@')[0].split('.')[1])
   } */
   return `${session?.givenName} ${session?.familyName}`
}

export {GetUserName,CapitalizeFirstLetter}
